import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import store from "@/store/index";
export default {
  __name: 'App',
  setup(__props) {
    if (window.innerWidth <= 800) {
      store.commit("setIsPhone", true);
    }
    window.addEventListener("resize", () => {
      let state = false;
      if (window.innerWidth <= 800) {
        state = true;
      }
      store.commit("setIsPhone", state);
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
};